type AssetLogoProps = {
  src: string;
  alt: string;
  className?: string;
};

export function AssetLogo({ src, alt, className = "" }: AssetLogoProps) {
  return <img src={src} alt={alt} className={`object-contain ${className}`} />;
}
